// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"fe4ba7caf64897d8af548745b1435a0ca9a6dbca"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";
import { SENTRY_DENY_URLS, SENTRY_IGNORE_ERRORS } from "analytics/sentry-constants";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_VAR_ENV === "production"
    ? "https://d108a948bd95449fa7f630b1358063cc@o144620.ingest.sentry.io/1187556"
    : "https://596320e355f14ffe9947943467ba9e98@o144620.ingest.sentry.io/2150904",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,
  autoSessionTracking: false,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.captureConsoleIntegration({ levels: ["error"] }),
    // Sentry.replayIntegration({
    //   // Additional Replay configuration goes in here, for example:
    //   maskAllText: false,
    //   blockAllMedia: false,
    //   networkDetailAllowUrls: [window.location.origin],
    // }),
  ],
  ignoreErrors: SENTRY_IGNORE_ERRORS,
  denyUrls: SENTRY_DENY_URLS,
  release: process.env.NEXT_PUBLIC_VERSION,
  beforeSend(event) {
    // Add fingerprint to de-group API FAILED errors
    if (event.tags?.endpoint) {
      event.fingerprint = [event.tags.endpoint];
    }

    const errorMessage =
      typeof event.message === "string"
        ? event.message
        : event.exception?.values?.[0]?.value;

    if (
      typeof errorMessage === "string" &&
      errorMessage.includes("Failed to load static props")
    ) {
      return null;
    }
    // Add network context to all events
    if (typeof navigator !== "undefined") {
      // Ensure contexts exists
      event.contexts = event.contexts || {};

      // Always start with online/offline
      const network: any = {
        online: navigator.onLine,
      };

      // Add advanced connection info when available (Chrome/Edge)
      if ("connection" in navigator) {
        const connection = (navigator as any).connection;
        network.effectiveType = connection?.effectiveType;
        network.downlink = connection?.downlink;
        network.rtt = connection?.rtt;
        network.saveData = connection?.saveData;
      }

      // Merge into event.contexts (do NOT overwrite!)
      event.contexts = {
        ...event.contexts,
        network,
        browser: {
          userAgent: navigator.userAgent,
        },
      };
    }

    return event;
  }

});
